module.exports = __webpack_public_path__ + "img/slide-bar-off_02.4a01bda8.png";